import Residents from './views/Residents.svelte';
import Resident from './views/Resident.svelte';
import Import from './views/Import.svelte';
import Sync from './views/Sync.svelte';
import Alerts from './views/Alerts.svelte';
import Alert from './views/Alert.svelte';
import Settings from './views/Settings.svelte';

const routes = {
  '/': Alert,
  '/residents': Residents,
  '/resident': Resident,
  '/resident/:resident_id': Resident,
  '/residents/import': Import,
  '/residents/sync': Sync,
  '/alerts': Alerts,
  '/alert': Alert,
  '/settings': Settings,
  '*': Residents
};

export default routes;